import {
  GamoraAdapterMemory,
  GamoraConstructorType,
  GamoraFoundationNode,
  GamoraFoundationNodeArgs,
} from '@ver.id/libs.internal.gamora';
import {
  HoruzProtocolChulakStoreChulakServerSessionNode,
  HoruzProtocolChulakStoreChulakServerSessionNodeArgs,
} from './server-session.js';
import {
  HoruzProtocolChulakStoreChulakServiceSessionNode,
  HoruzProtocolChulakStoreChulakServiceSessionNodeArgs,
} from './service-session.js';
import { IHoruz } from '../../../horuz.js';

/**
 * Children map
 * @public
 */
export interface HoruzProtocolChulakStoreNodeChildrenMap<TRoot extends IHoruz> {
  serverSession: GamoraConstructorType<
    HoruzProtocolChulakStoreChulakServerSessionNode<TRoot>,
    HoruzProtocolChulakStoreChulakServerSessionNodeArgs<TRoot>
  >;
  serviceSession: GamoraConstructorType<
    HoruzProtocolChulakStoreChulakServiceSessionNode<TRoot>,
    HoruzProtocolChulakStoreChulakServiceSessionNodeArgs<TRoot>
  >;
}

/**
 * Args
 * @public
 */
export interface HoruzProtocolChulakStoreNodeArgs<
  TRoot extends IHoruz,
> extends GamoraFoundationNodeArgs<
  HoruzProtocolChulakStoreNodeChildrenMap<TRoot>
> {
  serverSession?: HoruzProtocolChulakStoreChulakServerSessionNodeArgs<TRoot>;
  serviceSession?: HoruzProtocolChulakStoreChulakServiceSessionNodeArgs<TRoot>;
}

/**
 * HoruzProtocolChulakStoreNode
 * @public
 */
export class HoruzProtocolChulakStoreNode<
  TRoot extends IHoruz,
> extends GamoraFoundationNode<
  HoruzProtocolChulakStoreNodeChildrenMap<TRoot>,
  TRoot
> {
  constructor(args: HoruzProtocolChulakStoreNodeArgs<TRoot>) {
    super({
      ...args,
      childMap: {
        serverSession: [
          HoruzProtocolChulakStoreChulakServerSessionNode,
          args.serverSession ?? { adapter: new GamoraAdapterMemory() },
        ],
        serviceSession: [
          HoruzProtocolChulakStoreChulakServiceSessionNode,
          args.serviceSession ?? { adapter: new GamoraAdapterMemory() },
        ],
      },
    });
  }
}
